import { useTranslation } from 'react-i18next';

import { Text, Box, Flex } from '@radix-ui/themes';
import { StyledSelect } from '../../FormStyles';
import styles from './select_dropdown.module.css';

const SelectDropdown = ({
  title,
  name,
  handleChange,
  currentValue,
  options = [],
  showUserCount = false,
}) => {
  const { t } = useTranslation('tileForm');

  const selectedOption =
    options.find(option => option.value == currentValue) ||
    options.find(option => option.value === '') ||
    options[0] ||
    null;

  const onChange = selectedOption => {
    const syntheticEvent = {
      target: {
        name,
        value: selectedOption?.value ?? '',
      },
    };
    handleChange(syntheticEvent);
  };

  const userCount =
    showUserCount && selectedOption?.user_count !== undefined
      ? selectedOption.user_count
      : null;

  return (
    <Box py="4" width="100%">
      <Flex align="center" gap="2">
        <Text size="4" weight="medium">
          {title}
        </Text>
        {userCount !== null && (
          <Text as="span" className={styles.userCount}>
            {t('audience.userCount', { count: userCount })}
          </Text>
        )}
      </Flex>
      <Flex
        mt="4"
        width="100%"
        direction="column"
        align="start"
        className={styles.selectWrapper}
      >
        <StyledSelect
          className="audience-filter"
          classNamePrefix="react-select"
          options={options}
          value={selectedOption}
          onChange={onChange}
          isSearchable={true}
          isClearable={false}
        />
      </Flex>
    </Box>
  );
};

export default SelectDropdown;
